import { useMessageSource } from "react-message-source";

interface ResidencePermitValueType {
  id: string;
  value: string;
  label: string;
}

export default function useResidencePermitValues(
  dataPath = "",
): ResidencePermitValueType[] {
  const { getMessage } = useMessageSource();
  return [
    {
      id: `${dataPath}permitType-B`,
      value: "B",
      label: "B",
    },
    {
      id: `${dataPath}permitType-C`,
      value: "C",
      label: "C",
    },
    {
      id: `${dataPath}permitType-other`,
      value: "OTHER",
      label: getMessage("PermitType.OTHER"),
    },
  ];
}
